import { Box, ClickAwayListener, useTheme } from '@mui/material';
import ExoForm from '../../ExoForm';
import { tokens } from '../../../../global/theme/tokens';
import { useTranslation } from 'react-i18next';
import { API_POST, DBRequest, useConfig } from '../../../../api/api';
import { useRef, useState } from 'react';

const NewWPEToDoElement = ({ className, onCancel, onSubmit, wpeId }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  const ref = useRef();

  // enter and the click away can both fire, and a slow request must not be
  // sent a second time - the ref blocks that before any render happens
  const isSending = useRef(false);
  const [isBusy, setIsBusy] = useState(false);

  const config = useConfig();

  const fields = [
    {
      label: t('Title'),
      type: 'text',
      key: 'name',
      autoComplete: 'off',
      focusOnMount: true,
    },
  ];

  function handleSubmit() {
    if (isSending.current) return;

    const newTask = ref?.current.dataCollection;
    if (!newTask?.name) {
      onCancel();
      return;
    }

    isSending.current = true;
    setIsBusy(true);

    DBRequest({
      config,
      path: `work-packages/elements/list/tasks`,
      method: API_POST({ ...newTask, status: 0, wpeId, sortIndex: 0 }),
      onResponse: onSubmit,
      // a failed request may be tried again
      onError: () => {
        isSending.current = false;
        setIsBusy(false);
      },
    });
  }

  return (
    <ClickAwayListener onClickAway={handleSubmit}>
      <Box
        className={`flex items-center gap-2 rounded-lg px-3 py-1 w-full ${className}`}
        // ExoForm does not submit on enter, so the key is caught here
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmit();
          }
        }}
        sx={{
          backgroundColor: colors.bgInput,
          border: '1px solid transparent',
          opacity: isBusy ? 0.5 : 1,
          pointerEvents: isBusy ? 'none' : 'auto',
        }}
      >
        <ExoForm
          outerClassName="w-full"
          ref={ref}
          fields={fields}
          noControls={true}
          onCancel={onCancel}
          onSubmit={handleSubmit}
        />
      </Box>
    </ClickAwayListener>
  );
};

export default NewWPEToDoElement;
